module.exports = __webpack_public_path__ + "img/fg1.7c2b1925.jpg";